import _ from 'lodash';

function SidebarTeamCtrl($rootScope, $location, $scope, $state, $interval, $window, toastr, AppSettings, AuthService, AnalysisService, BioService, PlanService, PlayerService, CommonService, AppContextService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;

  vm.editPlayer = function (player) {
    $state.go('Service.system', {
      obj: player
    });
  };

  vm.togglePlayer = function () {
    $rootScope.$emit('selectedPlayersChanged', _.filter(vm.appContext.players.ourTeam.all, 'Selected'));
  };

  vm.checkAll = function (check) {
    angular.forEach(vm.appContext.players.ourTeam.all, function (item) {
      item.Selected = check;
    });
    $rootScope.$emit('selectedPlayersChanged', _.filter(vm.appContext.players.ourTeam.all, 'Selected'));
  };

}

export default {
  name: 'SidebarTeamCtrl',
  fn: SidebarTeamCtrl
};
